// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__ApScI","Logo":"Toolbar_Logo__3Lk47","Menu":"Toolbar_Menu__AEkju","DesktopOnly":"Toolbar_DesktopOnly__LuPaL"};